import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "ClosedCaption"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M3 20H21C21.8284 20 22.5 19.3284 22.5 18.5V6.5C22.5 5.67157 21.8284 5 21 5H3C2.17157 5 1.5 5.67157 1.5 6.5V18.5C1.5 19.3284 2.17157 20 3 20ZM3 18.5V6.5H21V18.5H3ZM11.25 15.75H7.5C6.67157 15.75 6 15.0784 6 14.25V9.75C6 8.92157 6.67157 8.25 7.5 8.25H11.25V9.75H7.5V14.25H11.25V15.75ZM15 15.75H18.75V14.25H15V9.75H18.75V8.25H15C14.1716 8.25 13.5 8.92157 13.5 9.75V14.25C13.5 15.0784 14.1716 15.75 15 15.75Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/ClosedCaption.vue"]]);
